module.exports = __webpack_public_path__ + "img/avatar0.65c1be9d.png";